module.exports = __webpack_public_path__ + "static/media/arrow-left.1b374551.svg";